export default {
  memberLevel: {
    levelName: 'Level Name',
    minPoints: 'Min Points',
    maxPoints: 'Max Points',
    addLevel: 'Add Level',
    editLevel: 'Edit Level'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/mmc/memberLevel.js